import axios from 'axios'

export const sendOtp = async (email, otp_purpose = 2) => {
  const BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://pro.vibelinksapp.com/api'
  try {
    const response = await axios.post(`${BASE_URL}/send-otp`, {
      email,
      otp_purpose
    })
    return response.data
  } catch (err) {
    // Return the actual API error message instead of generic message
    return {
      success: false,
      message:
        err.response?.data?.message || err.message || 'Failed to send OTP'
    }
  }
}
